"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DATA_TABLE_NAME = exports.TASKS = exports.COMMANDS = exports.AGENT_BROADCAST_EVENTS = exports.CONTACT_BROADCAST_EVENTS = exports.BROADCAST_EVENTS = exports.APP_ERROR_TYPE = exports.CALL_MEMBER_TYPE = exports.CALL_MEMBER_STATUS = exports.SESSION_STATUS = exports.USER_ROLE = exports.AGENT_STATUS = void 0;
var AGENT_STATUS;
(function (AGENT_STATUS) {
    AGENT_STATUS["AVAILABLE"] = "AVAILABLE";
    AGENT_STATUS["BUSY"] = "BUSY";
    AGENT_STATUS["OFFLINE"] = "OFFLINE";
})(AGENT_STATUS = exports.AGENT_STATUS || (exports.AGENT_STATUS = {}));
var USER_ROLE;
(function (USER_ROLE) {
    USER_ROLE["GUEST"] = "GUEST";
    USER_ROLE["USER"] = "USER";
    USER_ROLE["ADMIN"] = "ADMIN";
    USER_ROLE["SUPER_ADMIN"] = "SUPER_ADMIN";
})(USER_ROLE = exports.USER_ROLE || (exports.USER_ROLE = {}));
var SESSION_STATUS;
(function (SESSION_STATUS) {
    SESSION_STATUS["CLAIMED"] = "CLAIMED";
    SESSION_STATUS["ONGOING"] = "ONGOING";
    SESSION_STATUS["CLOSED"] = "CLOSED";
})(SESSION_STATUS = exports.SESSION_STATUS || (exports.SESSION_STATUS = {}));
var CALL_MEMBER_STATUS;
(function (CALL_MEMBER_STATUS) {
    CALL_MEMBER_STATUS["JOINED"] = "JOINED";
    CALL_MEMBER_STATUS["CONNECTED"] = "CONNECTED";
    CALL_MEMBER_STATUS["RINGING"] = "RINGING";
    CALL_MEMBER_STATUS["PICKED_UP"] = "PICKED_UP";
    CALL_MEMBER_STATUS["ANSWERED"] = "ANSWERED";
    CALL_MEMBER_STATUS["ON_HOLD"] = "ON_HOLD";
    CALL_MEMBER_STATUS["MUTED"] = "MUTED";
    CALL_MEMBER_STATUS["ERROR"] = "ERROR";
    CALL_MEMBER_STATUS["BUSY"] = "BUSY";
    CALL_MEMBER_STATUS["NOT_CONNECTED"] = "NOT_CONNECTED";
    CALL_MEMBER_STATUS["DISCONNECTED"] = "DISCONNECTED";
    CALL_MEMBER_STATUS["HANG_UP"] = "HANG_UP";
})(CALL_MEMBER_STATUS = exports.CALL_MEMBER_STATUS || (exports.CALL_MEMBER_STATUS = {}));
var CALL_MEMBER_TYPE;
(function (CALL_MEMBER_TYPE) {
    CALL_MEMBER_TYPE["AGENT"] = "agent";
    CALL_MEMBER_TYPE["CONTACT"] = "contact";
    CALL_MEMBER_TYPE["THIRD_PARTY"] = "3rd_party";
})(CALL_MEMBER_TYPE = exports.CALL_MEMBER_TYPE || (exports.CALL_MEMBER_TYPE = {}));
var APP_ERROR_TYPE;
(function (APP_ERROR_TYPE) {
    APP_ERROR_TYPE["INTERNAL"] = "internal";
    APP_ERROR_TYPE["NOT_FOUND"] = "not-found";
    APP_ERROR_TYPE["BAD_REQUEST"] = "bad-request";
    APP_ERROR_TYPE["NOT_UNIQUE"] = "not-unique";
    APP_ERROR_TYPE["DB_VALIDATION"] = "database-validation";
    APP_ERROR_TYPE["INPUT_VALIDATION"] = "input-validation";
    APP_ERROR_TYPE["MIGRATION_CONFLICT"] = "migrations-already-running";
    APP_ERROR_TYPE["MIGRATION_DATA_COPY"] = "migration-data-copy";
    APP_ERROR_TYPE["MIGRATION_DATA_CLEAN_UP"] = "migration-data-clean-up";
    APP_ERROR_TYPE["MIGRATION_ERROR"] = "migration-error";
})(APP_ERROR_TYPE = exports.APP_ERROR_TYPE || (exports.APP_ERROR_TYPE = {}));
/** These events are received by clients, usually using WebSocket */
exports.BROADCAST_EVENTS = {
    ADD_EVENTS: 'ADD_EVENTS',
    CLOSE_SESSION: 'CLOSE_SESSION',
    UPSERT_SESSION: 'UPSERT_SESSION',
    DELETE_SESSION: 'DELETE_SESSION',
    NOTIFY_AGENTS: 'NOTIFY_AGENTS',
    MULTI_ACTION: 'MULTI_ACTION',
    START_CALL: 'START_CALL',
    UPSERT_CONFERENCE_MEMBER: 'UPSERT_CONFERENCE_MEMBER',
    DELETE_CONFERENCE_MEMBER: 'DELETE_CONFERENCE_MEMBER',
    SHOW_ACW: 'SHOW_ACW',
};
exports.CONTACT_BROADCAST_EVENTS = {
    DELETE: 'DELETE_CONTACT',
    UPSERT: 'UPSERT_CONTACT',
    CREATE: 'CREATE_CONTACT',
    UPDATE: 'UPDATE_CONTACT',
    MERGE: 'MERGE_CONTACTS',
};
exports.AGENT_BROADCAST_EVENTS = {
    SET_AGENT_STATUS: 'SET_AGENT_STATUS',
};
exports.COMMANDS = {
    CONTINUE: 'continue',
    NOT_CLAIMED: 'notclaimed',
    CLAIM_TIMER: 'claim-timer',
    CHANGE_CONTACT: 'change-contact',
};
exports.TASKS = {
    SHARE_CARDS_TO_AGENTS: 'shareCardsToAgents',
    CLEAN_UP_CONTACT_BOOK_CACHE: 'cleanUpContactBookCache',
};
var DEFAULT_DATA_TABLE_NAME;
(function (DEFAULT_DATA_TABLE_NAME) {
    DEFAULT_DATA_TABLE_NAME["FILTERS"] = "FILTERS";
    DEFAULT_DATA_TABLE_NAME["EVENT_TEMPLATES"] = "EVENT_TEMPLATES";
    DEFAULT_DATA_TABLE_NAME["SETTINGS"] = "SETTINGS";
    DEFAULT_DATA_TABLE_NAME["RULE_GROUPS"] = "RULE_GROUPS";
})(DEFAULT_DATA_TABLE_NAME = exports.DEFAULT_DATA_TABLE_NAME || (exports.DEFAULT_DATA_TABLE_NAME = {}));
//# sourceMappingURL=api.js.map